<template>
    <div v-if="plan !== null">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="サービスモデル削除"
            @hidden="close">
            <div class="jumbotron pt-3 pb-3">
                <p class="mb-0">サービスモデル番号：#{{ plan.id }}</p>
                <p class="mb-0">サービスモデル名：{{ plan.name }}</p>
            </div>
            <p class="text-center">上記のサービスモデルを削除します。よろしいですか？</p>
            <div
                slot="modal-footer"
                class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-danger float-right"
                    style="width:90px;"
                    :disabled="inProgress"
                    @click="deletePlan">
                    削除
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                plan: null,
            }
        },

        created: function () {
            bus.$on('open-modal-admin-delete-plan', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-delete-plan')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {object} plan
             */
            open: function (plan) {
                this.plan = { ...plan }
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * プラン削除
             */
            deletePlan: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.delete(`${constants.admin.plans.endpoint.base}/${this.plan.id}`)
                    .then(() => {
                        bus.$emit('alert-success', 'サービスモデルを削除しました。')
                        bus.$emit('plan-deleted')
                        this.errors = {}
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },
        },
    }
</script>
